import React, { useState, useEffect } from 'react';
import { Button, Form, Container, Alert, Table } from 'react-bootstrap';
import axios from './axiosConfig';
import './UserPanel.css';

interface IPWhitelistEntry {
    ID: number;
    IPRange: string;
    IsCIDR: boolean;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
}

const IPWhitelistForm: React.FC = () => {
    const [ipRange, setIpRange] = useState<string>('');
    const [isCIDR, setIsCIDR] = useState<boolean>(false);
    const [whitelist, setWhitelist] = useState<IPWhitelistEntry[]>([]);
    const [showSuccess, setShowSuccess] = useState<boolean>(false);
    const [showError, setShowError] = useState<boolean>(false);

    useEffect(() => {
        fetchWhitelist();
    }, []);

    const fetchWhitelist = async () => {
        try {
            const response = await axios.get<IPWhitelistEntry[]>('/api/whitelist');
            setWhitelist(response.data);
        } catch (error) {
            console.error('Failed to fetch whitelist', error);
        }
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        try {
            const response = await axios.post('/api/whitelist', { IPRange: ipRange, IsCIDR: isCIDR });
            if (response.status === 200) {
                setShowSuccess(true);
                setShowError(false);
                setIpRange('');
                setIsCIDR(false);
                fetchWhitelist(); // Refresh the list after adding
            } else {
                throw new Error('Failed to add to whitelist');
            }
        } catch (error) {
            setShowError(true);
            setShowSuccess(false);
        }
    };

    return (
        <Container className="p-3">
            <h1>Add IP Whitelist Entry</h1>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                    <Form.Label>IP Range</Form.Label>
                    <Form.Control
                        type="text"
                        value={ipRange}
                        onChange={e => setIpRange(e.target.value)}
                        placeholder="Enter IP range"
                        required
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Check
                        type="checkbox"
                        label="Is network segment?"
                        checked={isCIDR}
                        onChange={e => setIsCIDR(e.target.checked)}
                    />
                </Form.Group>
                <Button variant="primary" type="submit">
                    Add to Whitelist
                </Button>
            </Form>
            {showSuccess && <Alert variant="success" onClose={() => setShowSuccess(false)} dismissible>
                Entry added successfully!
            </Alert>}
            {showError && <Alert variant="danger" onClose={() => setShowError(false)} dismissible>
                Failed to add entry. Please try again.
            </Alert>}

            <h2>Whitelist Entries</h2>
            <Table striped bordered hover size="sm" responsive variant="dark">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>IP Range</th>
                        <th>A network segment?</th>
                    </tr>
                </thead>
                <tbody>
                    {whitelist.map((entry) => (
                        <tr key={entry.ID}>
                            <td>{entry.ID}</td>
                            <td>{entry.IPRange}</td>
                            <td>{entry.IsCIDR ? 'Yes' : 'No'}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Container>
    );
};

export default IPWhitelistForm;
